module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-forget-body-content-msg"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/img/forget_success.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "message",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "link-login-a",
    attrs: {
      "to": "'/login'"
    }
  }, [_vm._v("立即登录")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-205bead9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/login/ForgetSuccess.vue
// module id = +Zpl
// module chunks = 273